import { render } from "./SpacePersonComponent.vue?vue&type=template&id=0908ef33&scoped=true&ts=true"
import script from "./SpacePersonComponent.vue?vue&type=script&lang=ts"
export * from "./SpacePersonComponent.vue?vue&type=script&lang=ts"

import "./SpacePersonComponent.vue?vue&type=style&index=0&id=0908ef33&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0908ef33"]])

export default __exports__